import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaApple, FaGooglePlay } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/Footer-css/Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        <div className="footer-section about">
          <h3>READY2RENTAL</h3>
          <p>Your trusted partner for home services — quality, convenience, and reliability.</p>
        </div>

        <div className="footer-section links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/become-partner">Become Partner</Link></li>
            <li><Link to="/resources">Resources</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h4>Contact Us</h4>
          <p>Email: contact@ready2rental.com</p>
          <p>Phone: +91 8608462631</p>
          <p>Address: OMR Road, Navallur, Chennai-603103</p>
        </div>

        <div className="footer-section social">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="social-icon facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter" className="social-icon twitter">
              <FaTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="social-icon instagram">
              <FaInstagram />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="social-icon linkedin">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* === New App Download Card === */}
        <div className="footer-section app-download-card">
          <h4>Download the Ready2Rental App</h4>
          <p>Book services on the go and get exclusive offers!</p>
          <div className="app-buttons">
            <a href="#" className="app-btn">
              <FaApple /> App Store
            </a>
            <a href="#" className="app-btn">
              <FaGooglePlay /> Google Play
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Ready2Rental. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
